import React from 'react';
import '../template-file-css/document-file-template.css';


export const RNFI_Roi = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RNFI_Roi' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><center> <h3> <b> Authorization for Release of Information </b></h3></center></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Name of Client or Guardian</span>
                        </td>
                        </tr>
                        <tr>
                        <td className='w-750'>
                            <input type="text" id='txtClientOfName' name='txtClientOfName' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Client SS# and/or Birth Date</span>
                        </td>
                        </tr>
                        <tr>
                        <td className='w-375'>
                            <input type="text" id='txtClientBirthDate' name='txtClientBirthDate' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input  type='date' id='txtDateBirth' name='txtDateBirth' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h2 >I HEREBY REQUEST AND AUTHORIZE:</h2></p> <br />
                <table>
                    <tr>
                        <td className='w-150'>Name/Agency:
                        </td>
                        <td className='w-600'>Ravens Nest Foundation, INC
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Address:
                        </td>
                        <td className='w-600'>3875 Austell Rd, suite 303 Austell, GA 30106
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Phone:
                        </td>
                        <td className='w-600'>(770) 819-6825 office
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>FAX:
                        </td>
                        <td className='w-600'>(770)819-6826 fax
                        </td>
                    </tr> <br />
                </table>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>TO:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbToObtainRecordsFrom' name='cbToObtainRecords' className='add-only' value='ObtainRecordsFrom' /> OBTAIN RECORDS FROM <br />
                            <input type='checkbox' id='cbToReleaseRecordsTo' name='cbToReleaseRecords' className='add-only' value='ReleaseRecordsTo' /> RELEASE RECORDS TO <br />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name/Agency:</span>
                        </td>
                    </tr>
                    <tr><td className='w-375'>
                        <input type="text" id='txtNameAgency' name='txtNameAgency' className='add-only' />
                    </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'> Address</span>
                        </td>
                    </tr>
                    <tr><td className='w-375'>
                        <input type="text" id='txtAddress' name='txtAddress' className='add-only custom-add-only' />
                    </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Phone/Fax</span>
                        </td>
                    </tr>
                    <tr><td className='w-375'>
                        <input type="text" id='txtPhoneFax' name='txtPhoneFax' className='add-only' />
                    </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                        <span className='eleHeader'> To disclose the following specific information:</span>
                        </td><br />
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbToDisclosePsychiatricEvaluation' name='cbToDisclosePsychiatricEvaluation' className='add-only' value='PsychiatricEvaluation' /> Psychiatric Evaluation &nbsp;
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbToDisclosePsychologicalReports' name='cbToDisclosePsychologicalReports' className='add-only' value='PsychologicalReports' /> Psychological Reports &nbsp;
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbToDiscloseMedicalRecords' name='cbToDiscloseMedicalRecords' className='add-only' value='MedicalRecords' /> Medical Records
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbToDisclosePsychosocialHistory' name='cbToDisclosePsychosocialHistory' className='add-only' value='PsychosocialHistory' /> Psychosocial History&nbsp;&nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbToDiscloseTreatmentPlan' name='cbToDiscloseTreatmentPlan' className='add-only' value='TreatmentPlan' /> Treatment Plan&nbsp;
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbToDiscloseCaseRecordsReports' name='cbToDiscloseCaseRecordsReports' className='add-only' value='CaseRecordsReports' /> Case Records/Reports
                        </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbToDiscloseLabsDrugScreensEtc' name='cbToDiscloseLabsDrugScreensEtc' className='add-only' value='LabsDrugScreensEtc' /> Labs (Drug Screens,etc) &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbToDiscloseOther' name='cbToDiscloseOther' className='add-only' value='Other' /> Other:
                            &nbsp;
                            <input type='text' id='txtToDisclose' name='txtToDisclose' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><span className='eleHeader'>FOR THE PURPOSE OF</span>
                    <textarea id='txtForPurposeOf' name='txtForPurposeOf' className='add-only'></textarea><br />
                    I understand that the Federal Privacy Rule (HIPAA) does not protect the privacy of information if re-disclosed
                    and therefore request that all information obtained from this person or agency be held strictly confidential
                    and not be further released by the recipient. I further understand that my eligibility for benefits, treatment or
                    payment is not conditioned upon my provision of this authorization. I intend this document to be a valid
                    authorization conforming to all requirements of the Privacy Rule. I understand that unless otherwise limited
                    by state or federal regulations and except to the extent that action has been taken which was based on my
                    consent, I may withdraw this consent at any time. If not previously revoked, this consent will terminate one
                    year from the date appearing below.

                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'> </td>
                    </tr>
                    <tr>
                        <td className="small w-375"> Client</td>
                        <td className="small w-375"> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'> </td>
                    </tr>
                    <tr>
                        <td className="small w-375"> Guardian</td>
                        <td className="small w-375"> Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'> </td>
                    </tr>
                    <tr>
                        <td className="small w-375"> Witness</td>
                        <td className="small w-375"> Date:</td>
                    </tr>

                </table>


            </div>
        </form>

    )
}











